import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  TrackerAddQuickMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
  withMobileAppMode,
} from '@front-activerse/common-components';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';
import TrackerQuickMealForm from './TrackerQuickMealForm';
import { emptyQuickMeal } from './helpers';
import { hasDietOrAiAccess } from '../helpers/paidAccess';
import { getTrackerMealPlaceholderImage } from '../helpers/trackerMealPlaceholder';

interface TrackerQuickMealPageProps {
  mobileAppMode?: boolean;
  /** Mounted under /meals/user-meals: the meal becomes a Your Meals template instead of a log entry. */
  fromUserMeals?: boolean;
}

/**
 * Entry point of "Add quick meal" from either action sheet. Creating a quick meal needs the diet
 * plan OR the AI plan (product rule); the native webview skips the check like every other tracker
 * gate, because the access flags are never written there.
 */
const TrackerQuickMealPage: React.FC<TrackerQuickMealPageProps> = ({
  mobileAppMode = false,
  fromUserMeals = false,
}) => {
  const location = useLocation();
  const {
    post,
    consts: { APP_BRAND },
  } = useAppContext();

  if (!mobileAppMode && !hasDietOrAiAccess()) {
    return <TrackerNoAccess />;
  }

  sessionStorage.setItem('tracker_depth', '1');

  return (
    <TrackerAddQuickMealConnectorApollo post={post}>
      {({ addQuickMeal }) => (
        <SaveAsUserMealConnectorApollo post={post}>
          {({ saveAsUserMeal }) => (
            <TrackerQuickMealForm
              key={location.key}
              mealData={emptyQuickMeal(getTrackerMealPlaceholderImage(APP_BRAND as string))}
              addQuickMeal={addQuickMeal}
              saveAsUserMeal={saveAsUserMeal}
              fromUserMeals={fromUserMeals}
              webviewModal
            />
          )}
        </SaveAsUserMealConnectorApollo>
      )}
    </TrackerAddQuickMealConnectorApollo>
  );
};

export default withMobileAppMode(TrackerQuickMealPage);
